import { createTypes, asyncType, createNS } from '@/utils/actionCreator';

export const NS = createNS('USER_INVITE');

export default createTypes([...asyncType('INVITE_POST')], `${NS}`);
